import cloneDeep from 'lodash.clonedeep';
import React from 'react';
import { FileZipDownloadRequest } from '../types/facilitator/file-zip-download';
import { downloadFilesAndZip } from '../utils/file-utility';

export const useDownloadSelected = (filename: string) => {
  const [selectedDownload, setSelectedDownload] = React.useState<string[]>([]);

  const onAddRemoveSelectedDownload = (value: string, checked: boolean) => {
    if (checked) {
      setSelectedDownload((prev) => [...prev, value]);
    } else {
      const getIdx = selectedDownload.findIndex((e) => e === value);
      if (getIdx !== -1) {
        const result = cloneDeep(selectedDownload);
        result.splice(getIdx, 1);
        setSelectedDownload(result);
      }
    }
  };

  const onDownloadSelected = () => {
    const filesToDownload: FileZipDownloadRequest[] = selectedDownload.map(
      (url) => ({
        containerFolder: '',
        fileUrl: url
      })
    );

    if (filesToDownload.length > 0) {
      downloadFilesAndZip(filesToDownload, filename);
    }
  };

  const onResetSelected = () => setSelectedDownload([]);

  return {
    selectedDownload,
    onResetSelected,
    onDownloadSelected,
    onAddRemoveSelectedDownload
  };
};
